import { request } from '@umijs/max';

// 获取日志列表
export async function getAdmLogPage({
  pageSize,
  current,
  filter,
  sorter,
}: {
  pageSize: number;
  current: number;
  filter: API.FormValues;
  sorter: string;
}) {
  return request('/api/admin/admUserLog/page', {
    method: 'POST',
    data: {
      pageSize,
      current,
      filter,
      sorter,
    },
  });
}

// 获取全部日志
export async function getAdmLogAll({ filter }: { filter: API.FormValues }) {
  return request('/api/admin/admUserLog/all', {
    method: 'POST',
    data: {
      filter,
    },
  });
}

// 获取日志详情
export async function getAdmLogInfo(values: API.FormValues) {
  return request('/api/admin/admUserLog/info', {
    method: 'POST',
    data: values,
  });
}

// 获取日志列表
export async function getAdmLogList() {
  return request('/api/admin/admUserLog/getList', {
    method: 'POST',
  });
}

// 删除日志
export async function removeAdmLog(values: API.FormValues) {
  return request('/api/admin/admUserLog/remove', {
    method: 'POST',
    data: values,
  });
}
